import {
  localStorageGet,
  localStorageSet,
} from '../../scripts/utils/localstorage';

const isAuthenticated = (key) => localStorageGet(key) !== null;
const checkAccess = (key) => {
  if (isAuthenticated(key)) {
    document.body.classList.add('template-suffix-builder_portal--active');
  }
};
const authenticate = (key) => {
  const loginErrorEl = document.querySelector(
    '[data-builder-portal-login-error]'
  );
  const input = document.querySelector('[data-builder-portal-login-input]');
  const { value } = input;
  const ok = value.indexOf('Brilliant_216') !== -1;

  if (ok) {
    localStorageSet(key, 'true');
    checkAccess();
  } else {
    loginErrorEl.setAttribute('data-error', 'true');
    input.focus();
  }

  return ok;
};

export const initBuilderPortalAuth = () => {
  const LOCAL_STORAGE_KEY = 'bbp-auth';
  const portalLoginSubmit = document.querySelector(
    '[data-builder-portal-login-submit]'
  );

  checkAccess(LOCAL_STORAGE_KEY);
  portalLoginSubmit.addEventListener('click', () => {
    authenticate(LOCAL_STORAGE_KEY);
  });
};
